import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Classnames from 'classnames'
import Modal from 'react-responsive-modal'
import { deletePersonalStrategy, showPersonalStrategy, showAllStrategies, showStrategyEditor, handleCheckbox } from '../../../actions/data'
import { addScreenedFund, removeScreendFund, removeSearchTicker } from '../../../actions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faClock, faEdit, faInfo } from '@fortawesome/free-solid-svg-icons'
import { formatDate, formatTime } from '../../../common'
import './StrategyRow.css'
import StrategyAnalysis from './StrategyAnalysis.js'
import i18n from '../../../i18n'
library.add(faClock, faInfo, faEdit)

class StrategyRow extends PureComponent {
  static defaultProps = {
    saveInProgress: false,
    openMenu: false,
    striped: false
  }

  constructor(props) {
    super(props)
    this.handleDeleteClick = this.handleDeleteClick.bind(this)
    this.handleCloseDeleteModal = this.handleCloseDeleteModal.bind(this)
    this.handleDeleteConfirmation = this.handleDeleteConfirmation.bind(this)
    this.handleMenuClick = this.handleMenuClick.bind(this)
    this.handleShowEditor = this.handleShowEditor.bind(this)
    this.handleBreadcrumbClick = this.handleBreadcrumbClick.bind(this)

    this.state = {
      startDeletion: false,
      openMenu: this.props.openMenu,
      MasterChecked: false,
      SelectedList: [],
      isChecked: false
    }
  }

  handleDeleteClick() {
    this.setState({
      startDeletion: true
    })
  }

  handleCloseDeleteModal() {
    this.setState({
      startDeletion: false
    })
  }

  handleDeleteConfirmation(idToDelete) {
    this.setState({
      startDeletion: false
    })
    this.props.deletePersonalStrategy(idToDelete)
  }

  handleMenuClick(idToShow) {
    !this.props.openMenu ? this.props.showPersonalStrategy(idToShow) : this.props.showAllStrategies()
  }

  handleShowEditor(strategyToEdit) {
    this.props.showStrategyEditor(strategyToEdit)
  }

  handleCheckbox(strategyToEdit) {
    const { id, name, periodicity, holdings } = strategyToEdit
    const externalID = id
    const ticker = holdings[holdings.length - 1].tickers.map(t => `${t}`).join(',')
    let type;
    if (strategyToEdit.customUserModel) {
        type = 'cod';
    } else {
        type = 'blend';
    }
    const rebalance_fq = periodicity
    const filteredFund = { id, externalID, ticker, rebalance_fq, name, type }
    const foundFund = this.props.screenedFunds && this.props.screenedFunds.find(fund => fund.id === filteredFund.id)
    if (foundFund) {
      this.props.removeScreendFund(externalID)
      this.props.removeSearchTicker(externalID)
      this.setState({ isChecked: false })
    } else {
      this.props.addScreenedFund(filteredFund)
      this.setState({ isChecked: true })
    }
    // this.props.handleCheckbox(strategyToEdit)
  }

  handleBreadcrumbClick(breadcrumb) {
    let nav = document.getElementById(breadcrumb)

    if (nav) {
      nav.scrollIntoView({
        block: 'center',
        behavior: 'smooth'
      })
    }
  }

  componentDidMount() {
    this.handleCheckBoxState()
  }

  componentDidUpdate(prevProps) {
    if (this.props.screenedFunds !== prevProps.screenedFunds) {
      this.handleCheckBoxState()
    }
  }

  handleCheckBoxState = () => {
    const { personalStrategy } = this.props
    const foundFund = this.props.screenedFunds && this.props.screenedFunds.find(fund => fund.id === personalStrategy.id)
    this.setState({ isChecked: foundFund ? true : false })
  }
  render() {
    const { personalStrategy, saveInProgress, striped, openMenu } = this.props
    const { isChecked, startDeletion } = this.state
    const latestAnalysis = personalStrategy.latestAnalysis
    const holdingsCount = latestAnalysis?.holdings[0]?.tickers?.length

    return (
      <div>
        <div className={Classnames('strategyBlendRow', { striped: striped && !openMenu }, { opened: openMenu })}>
          <div className='check-box-group' onChange={() => this.handleCheckbox(personalStrategy)}>
            <FontAwesomeIcon style={{ color: isChecked ? 'initial' : '#0FACE7', marginLeft: '10px' }} size='2x' icon='plus-circle' onClick={() => this.handleCheckbox(personalStrategy)} />
          </div>

          <div className='name' >
            {personalStrategy.name}
          </div>

          {!openMenu && (
            <div className='last-updated'>
              {formatDate(personalStrategy.updateDate)} {formatTime(personalStrategy.updateDate)}
            </div>
          )}

          <div className='statistics'>{latestAnalysis && !openMenu && holdingsCount}</div>

          <div className='menu-buttons'>
            {!saveInProgress ? (
              <>
                <div className='menu-button' onClick={() => this.handleShowEditor(personalStrategy)}>
                  <FontAwesomeIcon icon='edit' size='lg' />
                </div>
                <div className='menu-button' onClick={this.handleDeleteClick}>
                  <div className='cross'>
                    <strong>✕</strong>
                  </div>
                </div>
              </>
            ) : (
              <div className='waiting' />
            )}
          </div>
        </div>

        {startDeletion && (
          <Modal open onClose={this.handleCloseDeleteModal} showCloseIcon={false} classNames={{ overlay: 'modal-overlay', modal: 'delete-modal', closeIcon: 'custom-closeIcon' }} center>
            <div>
              <br />
              {i18n.t('confirm-delete')}
              <strong>{personalStrategy.name}</strong>?
              <br />
              <br />
              <div className='align-right'>
                <button className='portfolio-button' onClick={() => this.handleDeleteConfirmation(personalStrategy.id)}>
                  {i18n.t('delete')}
                </button>
                <button className='portfolio-button' onClick={this.handleCloseDeleteModal}>
                  {i18n.t('cancel')}
                </button>
              </div>
            </div>
          </Modal>
        )}

        {openMenu && <StrategyAnalysis personalStrategy={personalStrategy} openHoldingsEditor={() => this.handleShowEditor(personalStrategy)} />}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    data: state.fundData,
    params: state.params,
    personalStrategies: state.strategies,
    screenedFunds: state.params.screenedFunds
  }
}

export default withRouter(
  connect(mapStateToProps, {
    deletePersonalStrategy,
    showPersonalStrategy,
    showAllStrategies,
    showStrategyEditor,
    handleCheckbox,
    addScreenedFund,
    removeScreendFund,
    removeSearchTicker
  })(StrategyRow)
)
